import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT.js";

export const GeneralService = {

    getAllAmenities: async () => {
        try {
            const response = await axios.get(ENDPOINTS.AMENITIES);
            return response.data;
        } catch (error) {
            console.error("Error fetching amenities:", error);
            throw error; 
        }
    },
    getRoombyType: async () => {
        try {
            const response = await axios.get(ENDPOINTS.ROOMBYTYPE);
            return response.data;
        } catch (error) {
            console.error("Error fetching amenities:", error);
            throw error; 
        }
    },

    addSeasonalPrice: async (payload) => {
        try {
            const response = await axios.post(ENDPOINTS.SEASONAL_PRICE, payload);
            return response.data;
        } catch (error) {
            console.error(error);
            
        }
    },

    updateRoomPrice: async (payload) => {
        try {
            const response = await axios.patch(ENDPOINTS.PRICE_UPDATE, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching amenities:", error);
            throw error; 
        }
    },
    createAmenity: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.AMENITIES, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    editAmenity: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.AMENITIES}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error editing amenity:", error);
            throw error; 
        }
    },
    deleteAmenity: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.AMENITIES}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting amenity:", error);
            throw error; 
        }
    },
    mediaUpload: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.MEDIA_UPLOAD, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; 
        }
    },
    mediaDelete: async (data) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.MEDIA_UPLOAD}/${data}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; 
        }
    },

    loyality_discount: async (phone) => {
        try {
            const response = await axios.post(`${ENDPOINTS.LOYALTY_OFFER}?phone=${phone}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    // one for all

    create: async (table, data) => {
        try {
            const response = await axios.post(`${ENDPOINTS.CREATE}?table=${table}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    edit: async (id, table, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.UPDATE}?table=${table}&id=${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    get: async (table) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET}?table=${table}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    getById: async (table, id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET_BY_ID}?table=${table}&id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    getReservationData: async (table, room_id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET}?table=${table}&room_id=${room_id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    getReserOccData: async ( room_id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.BOOK_LOG}?room_id=${room_id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    update: async (table,id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.UPDATE}?table=${table}&id=${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    delete: async (table,id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.DELETE}?table=${table}&id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    getServiceRequests: async (table, bl_id, br_id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET}?table=${table}&bl_id=${bl_id}&br_id=${br_id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    deleteBySrId: async (table,id) => {
    try {
            const response = await axios.delete(`${ENDPOINTS.DELETE}?table=${table}&sr_id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },

    cancelReservation: async (id,date) => {
    try {
            const response = await axios.delete(`${ENDPOINTS.CANCEL_RESER}?room_id=${id}&date=${date}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },


    getUserPermissions: async (userId) => {
        try {
            const response = await axios.get(`${ENDPOINTS.USER_PERMISSIONS}/${userId}/permissions`);
            return response.data;
        } catch (error) {
            console.error("Error fetching permissions:", error);
            throw error;
        }
    },

    saveUserPermissions: async (userId, permissions) => {
        try {
            const response = await axios.post(
                `${ENDPOINTS.USER_PERMISSIONS}/${userId}/permissions`,
                { permissions }
            );
            return response.data;
        } catch (error) {
            console.error("Error saving permissions:", error);
            throw error;
        }
    },
};
